import styled from '../../theme/styled-with-theme';
import { pxToRem } from '../../styles/utils';
import { mediaQueries } from '../../styles/media-queries';

import { Text } from '../Text';

export const ModalOverlay = styled('div')`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  z-index: 999;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 2vh 1rem;
`;

export const ModalContent = styled('div')<{ maxWidth?: number }>`
  max-width: ${({ maxWidth }) => pxToRem(maxWidth ? maxWidth : 800)};
  width: 100%;
  height: fit-content;
  background: #ffffff;
  border-radius: ${pxToRem(24)};
  box-shadow:
    0px 2px 6px 0px rgba(0, 0, 0, 0.1),
    0px 0px 2px 0px rgba(0, 0, 0, 0.08),
    0px 0px 0px 1px rgba(0, 0, 0, 0.2);
  padding: ${pxToRem(40)};
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;

  ${mediaQueries[0]} {
    width: 95%;
    padding: ${pxToRem(24)};
  }

  ${mediaQueries.min} {
    width: 90%;
    padding: ${pxToRem(32)};
  }

  ${mediaQueries.tablet} {
    width: 85%;
  }
`;

export const Header = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: ${pxToRem(32)};
`;

export const Title = styled(Text)`
  font-weight: ${({ theme }) => theme.fontWeight[600]};
  font-size: ${({ theme }) => theme.fontSize['2xl']};
  line-height: ${pxToRem(32)};
  text-align: center;
  color: #1a1a1a;
  margin-bottom: ${pxToRem(16)};
`;

export const Description = styled(Text)`
  font-weight: ${({ theme }) => theme.fontWeight[400]};
  font-size: ${({ theme }) => theme.fontSize['m']};
  line-height: ${pxToRem(24)};
  max-width: ${pxToRem(600)};
`;
